import React from 'react'
import Properties from '../Components/Property/Properties'

const LandlorddProperties = () => {
  return (
    <Properties />
  )
}

export default LandlorddProperties